import { Col, Row } from "antd";
import { useBannerMobileContext } from "../../../context/BannerMobileContext/BannerMobileContext";
import { BannerMobileFormData } from "../../../context/BannerMobileContext/constants";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import { FileUploadItem } from "./constants";


const BannerMobileFiles = () => {
	const { bannerMobileForm, setBannerMobileForm } = useBannerMobileContext();

	const handleFileChange = (files: FileData[] | null, key: keyof BannerMobileFormData["images"]) => {
		setBannerMobileForm(prevState => ({
			...prevState,
			images: {
				...prevState.images,
				[key]: files && files.length > 0 ? files[0].file : null,
			},
		}));
	};

	return (
		<>
			<Row gutter={20}>
				<Col span={20} key={FileUploadItem.key}>
					<FileUploadComponent
						title={FileUploadItem.label}
						onChange={(fileData: FileData[] | null) => handleFileChange(fileData, FileUploadItem.key as keyof BannerMobileFormData["images"])}
						isRequired={FileUploadItem.isRequired}
						dimensions={bannerMobileForm.isUpper ? FileUploadItem.dimensions.upper : FileUploadItem.dimensions.lower}
						maxFileSize={FileUploadItem.maxFileSize}
						allowedExtensions={FileUploadItem.extensions}
					/>
				</Col>
			</Row >
		</>
	);
};

export default BannerMobileFiles;
